import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'regionLabelMap',
  pure: true
})
export class RegionLabelMapPipe implements PipeTransform {
  constructor() {}
  transform(region: string): string {
    if (region === 'NA') {
      return 'North America';
    }
    return region;
  }
}
